const Calendar = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.5 5.5h-13v3h13v-3Zm-13 8v-3h3v3h-3Zm5 0v-3h3v3h-3Zm3 2h-3v3h3v-3Zm2 3v-3h3v3h-3Zm0-5v-3h3v3h-3Zm-10 2h3v3h-3v-3Zm-2-12v17h17v-17h-17Zm5 2.5h2v2h-2V6ZM15 6h-2v2h2V6Z"
        />
    </svg>
);

export default Calendar;
